module.exports = __webpack_public_path__ + "hyperion-v2-static/img/grd-welcome-background.6c5d9d46.png";